import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { TrainerProfile } from '@/types';

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  trainerProfile: TrainerProfile | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (
    email: string,
    password: string,
    professionalType: string,
    emailRedirectTo: string
  ) => Promise<{ signedIn: boolean }>;
  requestPasswordReset: (
    email: string,
    redirectTo?: string
  ) => Promise<void>;
  updatePassword: (password: string) => Promise<void>;
  signOut: () => Promise<void>;
  /** The signed-in user id right now, for checking results that finish after an await. */
  getCurrentUserId: () => string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
